import { useEffect, useState } from 'react'
import { getTestPrompts, updateTestPrompts } from '../../api/autotests'
import { useI18n } from '../../i18n'
import { useToast } from '../../contexts/ToastContext'
import { PageCard, PageSection } from '../../components/ui'
import { AccessDeniedView } from './components'
import '../../styles/pages/page-common.css'
import '../../styles/pages/autotests.css'

export default function AutotestsPromptsPage() {
  const { t } = useI18n()
  const { showToast } = useToast()

  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [accessDenied, setAccessDenied] = useState(false)

  const [fanSimulator, setFanSimulator] = useState('')
  const [analyzer, setAnalyzer] = useState('')

  useEffect(() => {
    setLoading(true)
    getTestPrompts()
      .then((res) => {
        setFanSimulator(res.fan_simulator || '')
        setAnalyzer(res.analyzer || '')
      })
      .catch((err) => {
        if (err?.status === 401 || err?.status === 403) setAccessDenied(true)
        else setError(err?.message || t('common.error'))
      })
      .finally(() => setLoading(false))
  }, [t])

  async function handleSave(e) {
    e.preventDefault()
    setSaving(true)
    try {
      const res = await updateTestPrompts({
        fan_simulator: fanSimulator,
        analyzer: analyzer,
      })
      setFanSimulator(res.fan_simulator || '')
      setAnalyzer(res.analyzer || '')
      showToast('Промпты сохранены', 'success')
    } catch (err) {
      if (err?.status === 401 || err?.status === 403) setAccessDenied(true)
      else showToast(err?.message || t('common.error'), 'error')
    } finally {
      setSaving(false)
    }
  }

  if (accessDenied) return <AccessDeniedView />

  return (
    <PageSection
      className="autotests-page"
      title="Промпты"
      subtitle="Настройка промптов для симулятора фана и анализатора логов"
    >
      {error && <p className="form-error">{error}</p>}
      {loading ? (
        <p className="autotests-muted">{t('common.loading')}</p>
      ) : (
        <form className="autotests-prompts-form" onSubmit={handleSave}>
          <PageCard className="autotests-prompt-card">
            <div className="autotests-prompt-header">
              <h3 className="autotests-prompt-title">🎭 Промпт симулятора фана</h3>
              <p className="autotests-muted">
                Системный промпт, определяющий поведение виртуального фана в тестовых диалогах
              </p>
            </div>
            <textarea
              className="autotests-prompt-textarea"
              rows={8}
              value={fanSimulator}
              onChange={(e) => setFanSimulator(e.target.value)}
              placeholder="You are simulating an OnlyFans fan..."
            />
          </PageCard>

          <PageCard className="autotests-prompt-card">
            <div className="autotests-prompt-header">
              <h3 className="autotests-prompt-title">📊 Промпт анализатора</h3>
              <p className="autotests-muted">
                Системный промпт для GPT-анализа логов диалогов
              </p>
            </div>
            <textarea
              className="autotests-prompt-textarea"
              rows={10}
              value={analyzer}
              onChange={(e) => setAnalyzer(e.target.value)}
              placeholder="You are an AI bot analytics expert..."
            />
          </PageCard>

          <div className="autotests-prompt-actions">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? '⏳ Сохранение…' : '💾 Сохранить промпты'}
            </button>
          </div>
        </form>
      )}
    </PageSection>
  )
}
